import { ReactElement } from "react";
import { useLocalization } from '@progress/kendo-react-intl';
import { enMessages } from "../../../../messages/en-US";
import { SvgIcon } from "@progress/kendo-react-common";
import useIdentityStore from "../../../../Zustand/identityStore";
import { Button } from "@progress/kendo-react-buttons";
import { warningTriangleIcon,  envelopIcon} from "@progress/kendo-svg-icons";

export default function NoSettingsPage(): ReactElement {
  const localizationService = useLocalization();
  const userProfile = useIdentityStore((store) => store.user?.profile);

  const onGetInTouchClick = () => {
    window.open(`mailto:support@greaseboss.com.au?Subject=${userProfile?.current_site_name} Support Request`, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="gb-text-normal text-lg text-center"
      style={{ borderRadius: '3px', padding: '40px 25px', margin: '30px auto'}}>
      <div className="text-center mb-5">
        <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '72px',
          height: '72px'
        }}>
          <SvgIcon icon={warningTriangleIcon} size="xxlarge" />
        </span>
      </div>
      <div>
        <div>{localizationService.toLanguageString('custom.settingsNotConfigured', enMessages.custom.settingsNotConfigured)}</div>
        <br />
        <div>{localizationService.toLanguageString('custom.contactSupport', enMessages.custom.contactSupport)}</div>
        <div className="flex items-center justify-center gap-2">
          <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '26px',
            height: '26px'
          }}>
            <SvgIcon icon={envelopIcon} />
          </span>
          <Button 
            fillMode="link" 
            style={{textDecoration:"underline", color: "blue"}} 
            onClick={onGetInTouchClick}
          >
            support@greaseboss.com.au
          </Button> 
        </div>
      </div>
    </div> 
  );
}
